module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list-cn@3x.5747bcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list-cn@3x.png
// module id = W+fy
// module chunks = 18